/* eslint-disable */
// @ts-nocheck
import type { Filter } from '../../../../../main/types/druidTypes';
export type OrType = 'or';
export const OR_TYPE: OrType = 'or';
export default class OrFilter {
  type: OrType;

  fields: Filter[];

  dimension: void;

  values: void;

  field: void;

  pattern: void;

  constructor(fields: Filter[]) {
    this.type = OR_TYPE;
    this.fields = fields ? fields : [];
  }
}
